import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import Mobile from "./Mobile.vue";
import Pc from "./Pc.vue";
import GlobalServices from "@/services/global";
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock(_Fragment, null, [_unref(GlobalServices).state.clientType === 'PC' ? (_openBlock(), _createBlock(Pc, {
        key: 0
      })) : _createCommentVNode("", true), _unref(GlobalServices).state.clientType === 'Mobile' ? (_openBlock(), _createBlock(Mobile, {
        key: 1
      })) : _createCommentVNode("", true)], 64);
    };
  }
});